import api from "./Api";

class SituacaoOrdemServicoService {
  GetSituacaoOrdemServico(payload) {
    return api.get("/v1/situacaoOrdemServico/" + payload).then((response) => {
      return response.data;
    });
  }

  PostSituacaoOrdemServico(payload) {
    return api.post("/v1/situacaoOrdemServico/", payload).then((response) => {
      return response.data;
    });
  }

  PutSituacaoOrdemServico(payload) {
    return api.put("/v1/situacaoOrdemServico/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteSituacaoOrdemServico(payload) {
    return api
      .delete("/v1/situacaoOrdemServico/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetSituacaoOrdemServicoOData(payload) {
    return api.get("/OData/SituacaoOrdemServico" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new SituacaoOrdemServicoService();
